export const RUNE_TYPE = {
  SPEED: "speed",
  LUCK: "luck",
  STAMINA: "stamina"
} as const

export type IRuneType = (typeof RUNE_TYPE)[keyof typeof RUNE_TYPE]

export interface IUserRuneBalanceItem {
  runeType: IRuneType
  value?: number
  deltaValue?: number
}
